import { useQuery } from '@tanstack/react-query';
import { PhotosApi } from 'api';

export function useGetVehiclePhotos(vehicleId) {
  return useQuery({
    queryKey: ['vehicle-photos', vehicleId],
    queryFn: () => PhotosApi.find(vehicleId),
  });
}
